// linted by Thang 2020-08-17

import React from 'react';
import '../App.css';
import MobileHeader from '../Components/MobileHeader';

export default function Review({ jurorName, logOut, jurorReportingDateTime, affidavitLink }) {
    return (
        <div>
            <MobileHeader jurorName={jurorName} jurorReportingDateTime={jurorReportingDateTime} logOut={logOut} />
            <p />
            <div className="Deferment">
                <p>
                    Thank you for filling out the questionnaire. According to your answer(s), your questionnaire is under review for eligibility of
                    Jury Duty. We will send a push notification to your phone once the review in finalized.
                </p>
                <p>
                    You may qualify for deferment. You can locate the instruction and the deferment affidavit{' '}
                    <a alt="Deferment affivadvit form" href={affidavitLink} target="_blank" rel="noopener noreferrer">
                        here
                    </a>
                    .
                </p>
                <div>
                    <button type="button" className="cta_button" onClick={logOut}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}
